import { render, staticRenderFns } from "./updateHESPassword.vue?vue&type=template&id=2231e927&scoped=true&"
import script from "./updateHESPassword.vue?vue&type=script&lang=tsx&"
export * from "./updateHESPassword.vue?vue&type=script&lang=tsx&"
import style0 from "./updateHESPassword.vue?vue&type=style&index=0&id=2231e927&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2231e927",
  null
  
)

export default component.exports